import {Component, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit {
  public model: any = {};
  public loading: boolean;
  success: boolean;

  constructor(private http: HttpClient) {
  }

  ngOnInit() {
  }

  contact(): void {
    this.loading = true;
    this.http.post('/send.php', {
      name: this.model.name,
      email: this.model.email,
      phone: this.model.phone,
      text: this.model.text
    }).subscribe();
    setTimeout(() => {
      this.loading = false;
      this.success = true;
    }, 1500);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/contact-us/contact-us.component.ts